import tx from "@/core/app/tx";
import auth from "@/core/app/auth";
function isAdmin(){
    return auth.hasPrivilege(auth.privileges.ADMIN);
}

const items = [
    {id: 10, nameTx: 'Cash', name: 'Cash'},  //0
    {id: 20, nameTx: 'Card', name: 'Card'}, // 1
    {id: 30, nameTx: 'TPV Web', name: 'TPV Web'}, // 2
    {id: 40, nameTx: 'Teller', name: 'Teller'}, // 3
    {id: 50, nameTx: 'Bank', name: 'Bank'},  // 4
    {id: 1, nameTx: 'Pending ERP', name: 'Pending ERP'}, // 5
];

const itemsForOperators = [
    {id: 10, nameTx: 'Cash', name: 'Cash'},
    {id: 20, nameTx: 'Card', name: 'Card'},

];

const itemsForOperatorsAdmin  = [
        ...itemsForOperators,
    {id: 50, nameTx: 'Bank', name: 'Bank'},
];

const itemsForOperatorsPack = [
    {id: 1, nameTx: 'Pending ERP', name: 'Pending ERP'},
    {id: 10, nameTx: 'Cash', name: 'Cash'},
    {id: 20, nameTx: 'Card', name: 'Card'},

];

const itemsForOperatorsPackAdmin = [
    ...itemsForOperatorsPack,
    {id: 50, nameTx: 'Bank', name: 'Bank'},
    ]



const itemsForSuper = [
    {id: 10, nameTx: 'Cash', name: 'Cash'},
    {id: 20, nameTx: 'Card', name: 'Card'},
    {id: 50, nameTx: 'Bank', name: 'Bank'},
    {id: 30, nameTx: 'Web', name: 'Web'},
    {id: -1,nameTx: 'Paid', name: 'Paid'}
];


const itemsForList = [
    {id: 0, nameTx: 'Todos', name: 'All', criteria: null},
    {id: 1, nameTx: 'Pending ERP', name: 'Pending ERP', criteria: { eq: 1 }},
    {id: 10, nameTx: 'Cash', name: 'Cash', criteria: { eq: 10 }},
    {id: 20, nameTx: 'Card', name: 'Card', criteria: { eq: 20 }},
    {id: 30, nameTx: 'Web', name: 'Web', criteria: { eq: 30 }},
    {id: 40, nameTx: 'Teller', name: 'Teller', criteria: { eq: 40 }},
    {id: 50, nameTx: 'Bank', name: 'Bank', criteria: { eq: 50 }},
];


const values = Object.freeze({
    CASH: 10,
    CARD: 20,
    WEB: 30,
    TELLER: 40,
    BANK: 50,
    PENDING_ERP: 1,

});


function getName(paymentMethodId) {
    switch (paymentMethodId) {
        case values.CASH:
        case "10"
        :
            return items[0].name;

        case values.CARD     :
        case "20":
            return items[1].name;

            case values.WEB      :
        case "30":
            return items[2].name;

        case values.TELLER   :
        case "40":
            return items[3].name;


            case values.BANK     :
        case "50":
            return items[4].name;


        case values.PENDING_ERP:
        case "1":get
            return items[5].name;
        default:
            return paymentMethodId;
    }
}

function translateNames() {
    for (let item of items) {
        item.name = tx.t(item.nameTx);
    }

    for (let item of itemsForOperators) {
        item.name = tx.t(item.nameTx);
    }

    for (let item of itemsForOperatorsPack) {
        item.name = tx.t(item.nameTx);
    }
    for (let item of itemsForList) {
        item.name = tx.t(item.nameTx);
    }
}

function getItems() {
    return items
}

function getItemsForList() {
    return itemsForList
}


function getItemsForOperators() {
    return isAdmin()? itemsForOperatorsAdmin : itemsForOperators;
}

function getItemsForOperatorsPack() {
    return isAdmin() ? itemsForOperatorsPackAdmin : itemsForOperatorsPack;
}

function getItemsForSuper() {
    return itemsForSuper;
}


export default {
    getItems, getItemsForOperators, getItemsForOperatorsPack,getItemsForSuper, getName, translateNames, values,getItemsForList
}



